import { useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";

/** `/clubs/:slug/posts/:postId` — load club bundle + enforce slug/post club match. */
export const FORUM_THREAD_SURFACE_CLUB = "club_thread";
/** `/community/thread/:id` — community-scoped URL (same `ClubPostThreadPage` shell as `/thread/:id`); chrome until post proves club-tied (then redirect to `/clubs/...`). */
export const FORUM_THREAD_SURFACE_COMMUNITY = "community_thread";
/** `/thread/:postId` — canonical post-id URL; chrome follows `post.club_id` after load. */
export const FORUM_THREAD_SURFACE_NEUTRAL = "neutral_thread";

/**
 * Single source of truth for which forum thread URL shape we are on.
 * Drives load strategy (club bundle vs post-only) and post-load chrome (community vs club).
 */
export function useForumThreadSurface() {
  const { slug, postId: routePostId, threadId } = useParams();
  const location = useLocation();

  const surface = useMemo(() => {
    const p = String(location.pathname || "");
    if (p.startsWith("/thread/")) return FORUM_THREAD_SURFACE_NEUTRAL;
    if (p.startsWith("/community/thread/")) return FORUM_THREAD_SURFACE_COMMUNITY;
    return FORUM_THREAD_SURFACE_CLUB;
  }, [location.pathname]);

  const postIdParam = routePostId ?? threadId;

  const loadWithoutClubBundle = surface !== FORUM_THREAD_SURFACE_CLUB;

  return {
    surface,
    slug,
    postIdParam,
    loadWithoutClubBundle,
  };
}
